// 👇️ ts-nocheck ignores all ts errors in the file
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
import * as React from "react";
import {
    Card, CardContent, CardActions, TextField, makeStyles,
    Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, CircularProgress, Button, InputBase,
    Switch, Chip
} from '@material-ui/core';
import { ApolloClient, InMemoryCache, gql } from '@apollo/client';
import { apolloClient as client } from "../data-provider/graphqlDataProvider";
import {createRule,rulesPatch}from './index';
import { useNotify} from "react-admin";
// let token: any = localStorage.getItem('credentials')
// const client = new ApolloClient({
//     uri: `${process.env.REACT_APP_DATAPROVIDER}`,
//     headers: { authorization: token },
//     cache: new InMemoryCache(),
//     defaultOptions: {
//         watchQuery: {
//             fetchPolicy: 'no-cache',
//             errorPolicy: 'ignore',
//         },
//         query: {
//             fetchPolicy: 'no-cache',
//             errorPolicy: 'all',
//         },
//     }
// });

const useStyles = makeStyles((theme) => ({
    root: {
        display: 'flex',
        justifyContent: 'center',
        flexWrap: 'wrap',
        listStyle: 'none',
        padding: theme.spacing(0.5),
        margin: 0,
        width: '100%'
    },
    chip: {
        margin: theme.spacing(0.5),
    },
    table: {
        minWidth: 650,
    }
}));

const productSeleceted = (productDiscount: Array<any>): Array<any> => {
    let result = []
    let productDiscountCopy = productDiscount.map(pd => Object.assign({}, pd))
    productDiscountCopy.forEach((pd: any) => {
        if (pd.enable) {
            delete pd.enable
            delete pd.__typename
            result.push(pd)
        }

    })
    return result
}

const productType: any = {
    MENTOR: "حامی",
    DIET: "رژیم",
    BUNDLE: "باندل",
    PSYCHOLOGY_SESSION: "جلسه روان‌شناسی",
    PARTNER_DISCOUNT: "تخفیف همکار"
}

const getQueryParams = () => {
    let search = window.location.hash.split('?')[1]
    const params = new URLSearchParams(search)
    return params.getAll("id")[0]
}

export function BundleEdit() {
    const classes = useStyles();
    const notify = useNotify();
    const [discountType, setDiscountType] = React.useState('FINAL_PRICE');
    const [allProducts, setAllProducts] = React.useState<Array<any>>([]);
    const [productDiscount, setProductDiscount] = React.useState<Array<any>>([]);
    const [rowsLoading, setRowsLoading] = React.useState(false);
    const [values, setValues] = React.useState({
        title: null,
        description: null,
        currency: 'تومان',
        subtitle: null,
        subtitle2: null,
        expiryPeriod: null,
        name: null,
        isEnabled: true,
        rules:[
            {id:'',isEnabled:false}
        ],
        id: null,
        loading: true,
        tags: [],
        showOrder: ''
    });
    const [status, setStatus] = React.useState({ loading: false, message: '', hasError: false });

    const handleDeleteTag = (chipToDelete) => () => {
        setValues({ ...values, tags: values.tags.filter((tag) => tag.key !== chipToDelete.key) })
    };

    const handleAddTag = (e, newTagLabel) => {
        let existTag = values?.tags?.some(t => t.key === newTagLabel.toUpperCase())
        let newTags = [...values?.tags ?? [], { key: newTagLabel.toUpperCase(), label: newTagLabel }]
        if (!existTag && newTagLabel !== "")
            setValues({ ...values, tags: newTags })
    }

    async function getBundle(bundleId) {
        const GET_BUNDLE = gql`
        query GetBundle($where: ProductWhereUniqueInput!){
            product(where: $where){
                id
                title
                description
                subtitle
                subtitle2
                name
                price
                offValue
                productType
                meta
                expiryPeriod
                service
                isEnabled
                rules {
                    id
                    isEnabled
                  }
                images
            }
          }
      `;
        return await client.query({
            query: GET_BUNDLE,
            variables: {
                where: {
                    id: bundleId,
                },
            }
        }).then((res) => {
            let productResult = res.data.product;
            setValues({
                title: productResult.title,
                description: productResult.description,
                subtitle: productResult.subtitle,
                subtitle2: productResult.subtitle2,
                expiryPeriod: productResult.expiryPeriod,
                name: productResult.name,
                isEnabled: productResult.isEnabled,
                rules:productResult.rules && productResult.rules.length > 0 ? productResult.rules : [{id:"",isEnabled:false}],
                loading: false,
                id: bundleId,
                tags: productResult.meta?.tags?.map((tag) => { return { key: tag.toUpperCase(), label: tag } }),
                showOrder: productResult.meta?.showOrder,
                orderTrackingUrl: productResult.meta?.orderTrackingUrl,
                paymentSuccessMessage: productResult.meta?.paymentSuccessMessage
            })
            return productResult.meta.products;
        })
    }

    async function getAllProducts(metaProducts: Array<any>) {
        const GET_Products = gql`
        query Products($where: ProductWhereInput) {
            products(where: $where) {
              id
              title
              subtitle
              subtitle2
              description
              price
              offValue
              productType
              meta
              expiryPeriod
              service
              isEnabled 
              images                           
            }
        }
      `;
        let result: Array<any> = await client.query({
            query: GET_Products,
            variables: {
                where: {
                    service: { equals: process.env.REACT_APP_SERVICE },
                    productType: { not: "BUNDLE" },
                    isEnabled:{ equals: true}
                },
            }
        }).then((res) => {
            return res.data.products;
        })
        setAllProducts(result);
        let pd = result.map(p => {
            let metaProduct = metaProducts.find(mp => mp.id === p.id)
            if (metaProduct)
                return { ...p, price: metaProduct.price, offValue: metaProduct.offValue, enable: true }
            else
                return { ...p, enable: false }
        });
        setProductDiscount(pd)
        setRowsLoading(true)
    }


    const handlerEnabled = (productId: any) => {
        console.log('handlerEnabled');
        let result = productDiscount.map((pd: any) => {
            if (pd.id === productId)
                return { ...pd, enable: !pd.enable };
            return pd;
        })
        setProductDiscount(result)
    }


    const handlerFinalPrice = (value: any, productId: any) => {
        let result = productDiscount.map((pd: any) => {
            if (pd.id === productId)
                return { ...pd, price: value ? Number(value) : 0 };
            return pd;
        })
        setProductDiscount(result)
    }

    const handlerOffValue = (value: any, productId: any) => {
        let result = productDiscount.map((pd: any) => {
            if (pd.id === productId)
                return { ...pd, offValue: value ? Number(value) : 0 };
            return pd;
        })
        setProductDiscount(result)
    }

    const submit = async () => {
        setStatus({ message: '', loading: true, hasError: false })

        let selectedProducts = productSeleceted(productDiscount);
        let data = {
            title: values.title,
            subtitle: values.subtitle,
            description: values.description,
            expiryPeriod: Number(values.expiryPeriod),
            name: values.name,
            currency: values.currency,
            isEnabled: values.isEnabled,
            meta: { 
                products: selectedProducts,
                tags: values.tags.map(tag => tag.label),
                showOrder: values.showOrder ,
                orderTrackingUrl: values.orderTrackingUrl,
                paymentSuccessMessage: values.paymentSuccessMessage
                },
            price: selectedProducts.reduce((prev, obj) => { return prev += obj.price }, 0),
            offValue: selectedProducts.reduce((prev, obj) => { return prev += obj.offValue }, 0),
            productType: "BUNDLE",
            service: "LIMOOME_SHOP",
            subtitle2: values.subtitle2
        }
        let partnerProduct = hasPartnerProduct(selectedProducts)
        if(partnerProduct)
            data = {...data, meta: {...data.meta, type: 'PARTNER_DISCOUNT'}}
            if (values.rules[0].id) {
                try {
                    let paramData = {  id: values.rules[0].id,   rulesEnabled: values.rules[0].isEnabled  }
                    let updateIsEnabled = await rulesPatch(paramData)
                    if (updateIsEnabled.data && updateIsEnabled.data.id) {
                        sendToServer(true,data)       
                    }
                  } catch (error) {
                    sendToServer(false,data)
        
                  }
            }else{
                const ruleData = await createRule({
                    isEnabled: values.rules[0].isEnabled ,
                    step: "BEFORE_SHOW_PRODUCT",
                    ruleAddress: "http://localhost:3080/api/limoome-integrations/can-buy-diet"
                }, values.id);
                if (ruleData.createRule && ruleData.createRule.id) {   
                    sendToServer(true,data)      
                  }else{
                    sendToServer(false,data)
                  }
            }
      
        
    }


    const sendToServer = async (status,data) => {
        if (status) {
            const CREATE_BUNDLE = gql`
            mutation UpdateBundle($where: ProductWhereUniqueInput!, $data: ProductUpdateInput!){
                updateProduct(data: $data, where: $where) {
                id    
                }
            }
          `;

        await client.mutate({
            mutation: CREATE_BUNDLE,
            variables: {
                where: { id: values.id },
                data: data
            }
        }).then((res) => {
            if (!res.data.errors) {
                setStatus({ loading: false, message: 'با موفقیت ثبت شد', hasError: false })
                setTimeout(() => {
                    window.location.href = `${process.env.REACT_APP_AUTH_PUBLIC_PATH}/#/Product`
                }, 1000);
                return res.data;
            }
            else
                setStatus({ loading: false, message: 'خطا در ثبت!', hasError: true })
        }).catch(e => {
            console.log('error catch: ', e)
            setStatus({ loading: false, message: 'خطا در ثبت!', hasError: true })
        })       
        }else{

            notify("خطا لطفا دوباره تلاش کنید ", { type: 'error' })
        }

    }

    const hasPartnerProduct = (products: Array<any>) => {
        console.log('hasPartnerProduct: ', products);
        return products.some(product => product.productType === "PARTNER_DISCOUNT")
    }

    React.useEffect(() => {
        let bundleId = getQueryParams()
        getBundle(bundleId).then((products: any) => {
            getAllProducts(products);
        })

    }, [])

    return (
        <Card>
            <CardContent>
                {
                    !values.loading ?
                        <div style={{ display: "flex", flexDirection: 'column', marginBottom: '1rem' }}>
                            <div style={{ display: "flex", gap: '1rem', alignItems: 'center', marginBottom: '1rem', justifyContent: 'space-between' }}>
                                <TextField fullWidth onChange={(e: any) => setValues({ ...values, title: e.target.value })} value={values.title} size="medium" label="عنوان" variant="outlined"></TextField>
                                <TextField fullWidth onChange={(e: any) => setValues({ ...values, subtitle: e.target.value })} value={values.subtitle} label="زیر عنوان" size="medium" variant="outlined"></TextField>
                            </div>
                            <div style={{ display: "flex", gap: '1rem', alignItems: 'center', marginBottom: '1rem', justifyContent: 'space-between' }}>
                                <TextField type="number" fullWidth onChange={(e: any) => setValues({ ...values, showOrder: Number(e.target.value) })} value={values.showOrder} label="ترتیب نمایش" size="medium" variant="outlined"></TextField>
                                <TextField fullWidth onChange={(e: any) => setValues({ ...values, subtitle2: e.target.value })} value={values.subtitle2} label="زیر عنوان 2" size="medium" variant="outlined"></TextField>
                            </div>
                            <div style={{ display: "flex", gap: '1rem', alignItems: 'center', marginBottom: '1rem', justifyContent: 'space-between' }}>
                                <TextField fullWidth onChange={(e: any) => setValues({ ...values, name: e.target.value })} value={values.name} label="کد محصول" size="medium" variant="outlined"></TextField>
                                <div style={{ width: '100%' }}></div>
                            </div>
                            <div style={{ marginBottom: '1rem' }}>
                                <TextField rows={3} multiline fullWidth onChange={(e: any) => setValues({ ...values, description: e.target.value })} value={values.description} size="medium" label="توضیحات" variant="outlined"></TextField>
                            </div>
                            <div style={{ display: "flex", flexDirection: 'row-reverse', gap: '1rem', alignItems: 'center', marginBottom: '1rem', justifyContent: 'space-between' }}>
                    <div style={{width:"50%"}}></div>
                    <div style={{ display: 'flex', justifyContent: 'center', width: '50%', alignItems: 'center' }}>
                            <Switch
                                checked={values.rules && values.rules[0] ? !values.rules[0].isEnabled : true}
                                onChange={(e: any) => setValues({
                                    ...values,
                                    rules: [
                                        {
                                            ...values.rules[0],  // Keep the existing properties of the first rule
                                            isEnabled: !values.rules[0].isEnabled  // Update the isEnabled property
                                        }
                                    ]
                                })}
                                color="primary"
                                name="checkedA"
                                inputProps={{ 'aria-label': 'secondary checkbox' }}
                            />
                            <p style={{ fontFamily: 'IranSans-Bold' }}>قابل خرید برای کاربران با رژیم فعال</p>
                        </div>
                      
                    </div>
                            <div style={{ display: "flex", flexDirection: 'row-reverse', gap: '1rem', alignItems: 'center', marginBottom: '1rem', justifyContent: 'space-between' }}>
                                <div style={{ display: 'flex', justifyContent: 'center', width: '100%', alignItems: 'center' }}>
                                    <Switch
                                        checked={values.isEnabled}
                                        onChange={(e: any) => setValues({ ...values, isEnabled: !values.isEnabled })}
                                        color="primary"
                                        name="checkedA"
                                        inputProps={{ 'aria-label': 'secondary checkbox' }}
                                    />
                                    <p style={{ fontFamily: 'IranSans-Bold' }}>فعال/غیرفعال</p>
                                </div>
                                <TextField type="number" fullWidth onChange={(e: any) => setValues({ ...values, expiryPeriod: e.target.value })}
                                    label="تاریخ انقضا سبد خرید" value={values.expiryPeriod} size="medium" variant="outlined"></TextField>
                            </div>
                            <div style={{ display: 'flex', flexDirection: 'row-reverse', gap: '1rem', alignItems: 'center' }}>
                                <div className={classes.root}>
                                    {values.tags?.map((data) => {
                                        return (
                                            <li key={data.key}>
                                                <Chip
                                                    label={data.label}
                                                    onDelete={handleDeleteTag(data)}
                                                    className={classes.chip}
                                                    variant="outlined"
                                                />
                                            </li>
                                        );
                                    })}

                                </div>
                                <TextField fullWidth onBlur={(e) => handleAddTag(e, e.target.value)} size="medium" label="تگ" variant="outlined"></TextField>

                            </div>
                        </div> : <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', marginTop: '5rem' }}>
                            <CircularProgress />
                        </div>

                }
                     <div style={{ display: "flex", gap: '1rem', alignItems: 'center', marginBottom: '1rem', justifyContent: 'space-between' }}>
                        <TextField type="text" fullWidth onChange={(e: any) => setValues({ ...values, orderTrackingUrl: e.target.value })} value={values.orderTrackingUrl} label="پیگیری سفارش" size="medium" variant="outlined"></TextField>
                        <TextField fullWidth onChange={(e: any) => setValues({ ...values, paymentSuccessMessage: e.target.value })} value={values.paymentSuccessMessage} label="  پیغام پرداخت موفق" size="medium" variant="outlined"></TextField>
                    </div>
                <p style={{ fontFamily: "IranSans-Bold" }}>محصولات مربوط به باندل را از جدول زیر انتخاب کنید:</p>
                {
                    rowsLoading ?
                        <TableContainer component={Paper}>
                            <Table className={classes.table} aria-label="a dense table">
                                <TableHead>
                                    <TableRow>
                                        <TableCell style={{ fontWeight: 700 }} align="center">محصول</TableCell>
                                        <TableCell style={{ fontWeight: 700 }} align="center">شناسه</TableCell>
                                        <TableCell style={{ fontWeight: 700 }} align="center">نوع محصول</TableCell>
                                        <TableCell style={{ fontWeight: 700 }} align="center">فعال/غیرفعال</TableCell>
                                        <TableCell style={{ fontWeight: 700 }} align="center">مبلغ اصلی</TableCell>
                                        <TableCell style={{ fontWeight: 700 }} align="center">مبلغ تخفیف</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {productDiscount.map((row) => (
                                        <TableRow key={row.id}>
                                            <TableCell align="center">{row.title}</TableCell>
                                            <TableCell align="center">{row.id}</TableCell>
                                            <TableCell align="center">{productType[row.productType]}</TableCell>
                                            <TableCell align="center">
                                                <Switch
                                                    checked={row.enable}
                                                    onChange={(e: any) => handlerEnabled(row.id)}
                                                    color="primary"
                                                    name="checkedA"
                                                    inputProps={{ 'aria-label': 'secondary checkbox' }}
                                                />
                                            </TableCell>
                                            <TableCell align="center">
                                                <InputBase
                                                    value={row.price}
                                                    onChange={(e: any) => handlerFinalPrice(e.target.value, row.id)}
                                                    disabled={!row.enable}
                                                    style={{ textAlign: 'center' }}
                                                    placeholder="مبلغ نهایی را وارد کنید"
                                                />
                                            </TableCell>
                                            <TableCell align="center">
                                                <InputBase
                                                    value={row.offValue}
                                                    onChange={(e: any) => handlerOffValue(e.target.value, row.id)}
                                                    disabled={!row.enable}
                                                    style={{ textAlign: 'center' }}
                                                    placeholder="مبلغ تخفیف را وارد کنید"
                                                />
                                            </TableCell>

                                        </TableRow>
                                    ))}
                                </TableBody>
                            </Table>
                        </TableContainer> :
                        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', marginTop: '5rem' }}>
                            <CircularProgress />
                        </div>
                }
                <div style={{ display: 'flex', alignItems: 'center', marginTop: '2rem', justifyContent: 'space-between' }}>
                    <Button onClick={() => submit()} style={{ color: '#fff' }} variant="contained" color="primary">ثبت</Button>
                    {
                        !status.loading && status.hasError && status.message ?
                            <section style={{ display: 'flex', backgroundColor: 'red', color: '#fff', padding: '5px', borderRadius: '8px', fontFamily: 'IranSans-Bold', fontSize: '14px', direction: 'rtl' }}>
                                {status.message}
                            </section>
                            :
                            <div></div>
                    }
                    {
                        !status.loading && !status.hasError && status.message ?
                            <section style={{ display: 'flex', backgroundColor: '#4fcc12', color: '#fff', padding: '5px', borderRadius: '8px', fontFamily: 'IranSans-Bold', fontSize: '14px', direction: 'rtl' }}>
                                {status.message}
                            </section>
                            :
                            <div></div>
                    }

                </div>
            </CardContent>
            <CardActions>

            </CardActions>
        </Card >
    )
}